/**
 * 模版市场-视频盒子组件
 * @author VenDream
 * @since 17/11/8
 */
import classnames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as ajax from '@fe/common/lib/ajax';

import './video-box.less';

// 补零
function padZero(n) {
  return n < 10 ? `0${n}` : n + '';
}

// 时长转换为时分秒
function parseDuration(duration) {
  const mm = padZero(Math.floor(~~duration / 60));
  const ss = padZero(~~duration % 60);

  return `${mm}:${ss}`;
}

class VideoBox extends Component {
  static propTypes = {
    container: PropTypes.object,
    tpl: PropTypes.object,
    onClickBox: PropTypes.func,
    setTplLikeStatus: PropTypes.func,
    isSystemDisabled: PropTypes.bool,
  };

  componentDidMount() {
    this.box && this.forceUpdate();
  }

  componentWillUnmount() {
    if (this.video) {
      // 取消事件监听
      this.video.removeEventListener('pause', this.updatePlayStatus);
      this.video.removeEventListener('playing', this.updatePlayStatus);
      this.video.removeEventListener('timeupdate', this.updateProgress);
    }
  }

  // 暂停其他正在播放的视频
  stopOtherVideos() {
    const playingVideo =
      window.RP_PLAYING_VIDEOS &&
      window.RP_PLAYING_VIDEOS.filter(video => !video.paused);
    playingVideo && playingVideo.length === 1 && playingVideo[0].pause();
  }

  // 更新播放进度条
  updateProgress = () => {
    const progress = parseFloat(this.video.currentTime / this.video.duration);
    this.progressbar.style.width = `${progress * 100}%`;

    // 播放结束
    if (this.video.ended) {
      this.coverImg.style.display = 'block';
      this.box.classList.remove('played');
    }
  };

  // 更新播放状态
  updatePlayStatus = () => {
    if (this.video.paused) {
      this.playIcon.style.display = 'block';
    } else {
      this.playIcon.style.display = 'none';
      this.coverImg.style.display = 'none';
    }
  };

  // 设置视频浏览记录
  handleVideoRecord = async () => {
    const { id } = this.props.tpl;
    try {
      const api = '/api/store/template/videoViewRecord';
      await ajax.post(api, { templateId: id });
    } catch (err) {
      console.error('设置短视频记录返回接口错误');
    }
  };

  // 播放视频
  playVideo = () => {
    const src = this.props.tpl.video['480p'];

    if (!this.box.classList.contains('played')) {
      // 重置进度条
      this.progressbar.style.transition = 'none';
      this.progressbar.style.width = '0%';
      setTimeout(() => {
        this.progressbar.style.removeProperty('transition');
      }, 0);

      this.box.classList.add('played');
    }

    // 继续播放/暂停
    if (this.video.src) {
      if (this.video.paused) {
        this.stopOtherVideos();
        this.video.play();
        // 设置视频浏览记录
        this.handleVideoRecord();
      } else {
        this.video.pause();
      }
    } else {
      // 首次播放
      this.video.src = src;
      this.stopOtherVideos();
      this.video.play();

      if (!window.RP_PLAYING_VIDEOS) {
        window.RP_PLAYING_VIDEOS = [];
      }
      window.RP_PLAYING_VIDEOS.push(this.video);

      // 事件监听
      this.video.addEventListener('pause', this.updatePlayStatus);
      this.video.addEventListener('playing', this.updatePlayStatus);
      this.video.addEventListener('timeupdate', this.updateProgress);
      // 设置视频浏览记录
      this.handleVideoRecord();
    }
  };

  // 点击立即使用按钮
  handleClick = () => {
    const { isSystemDisabled } = this.props;
    if (isSystemDisabled) return;

    this.video.pause();
    this.props.onClickBox();
  };

  render() {
    if (!this.props.container) return null;
    const {
      id,
      type,
      title,
      cover,
      duration,
      videoWidth,
      videoHeight,
      elementsText,
      elementsImage,
      elementsVideo,
      tplOrganizePrice,
    } = this.props.tpl;
    let { minimumPrice } = this.props.tpl;
    // 计算宽高
    const w = this.props.container.parentNode.getBoundingClientRect().width;
    const h = Math.ceil(w / (videoWidth / videoHeight));
    const coverStyle = {
      width: '100%',
      height: h,
    };
    const infoStyle = {
      width: '100%',
      height: `calc(100% - ${h}px)`,
    };
    const useBtnClass = classnames('use-btn', {
      disabled: this.props.isSystemDisabled,
    });
    //新接口还要考虑tplOrganizePrice，

    if (tplOrganizePrice !== null && tplOrganizePrice !== undefined) {
      minimumPrice = Math.min(+minimumPrice, +tplOrganizePrice);
    }
    return (
      <div
        className={`tpl-box ${type}`}
        data-tpl-id={id}
        ref={node => (this.box = node)}>
        <div className="play-area" style={coverStyle}>
          <img
            src={cover.sm}
            alt="VIDEO_COVER"
            className="video-cover"
            ref={node => (this.coverImg = node)}
          />
          <video poster={cover.sm} ref={node => (this.video = node)} />
          <div className="progress-bar">
            <div
              className="inner-bar"
              ref={node => (this.progressbar = node)}
            />
          </div>
          <div className="play-icon-bg" onClick={this.playVideo}>
            <span className="play-icon" ref={node => (this.playIcon = node)} />
          </div>
        </div>
        <div className="video-info" style={infoStyle}>
          <div className="video-title">
            <div className="flex-wrapper">
              <span className="title" title={title}>
                {title}
              </span>
              <span className="duration">{parseDuration(duration)}</span>
            </div>
          </div>
          <div className="video-detail">
            <span className="editable-elements">
              <span className="editable text" title="可替换文字">
                <span className="icon">
                  <i className="s-icon icon-font" />
                </span>
                <span className="count">{elementsText}</span>
              </span>
              <span className="editable image" title="可替换图片">
                <span className="icon">
                  <i className="s-icon icon-picture" />
                </span>
                <span className="count">{elementsImage}</span>
              </span>
              {elementsVideo ? (
                <span className="editable video" title="可替换视频">
                  <span className="icon">
                    <i className="s-icon icon-video" />
                  </span>
                  <span className="count">{elementsVideo}</span>
                </span>
              ) : null}
            </span>
            <span className="price">
              {minimumPrice ? (
                <span className="final-price">
                  {(+minimumPrice).toFixed(2)}元
                </span>
              ) : (
                <span className="free">
                  <i className="s-icon icon-label" />
                  免费
                </span>
              )}
            </span>
          </div>
          <div className="video-btn-bg">
            <span className={useBtnClass} onClick={this.handleClick}>
              立即使用
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default VideoBox;
